import { useIsModuleConnectedFn } from "@/shared/modules";

export function useFilterByRequiredModules() {
  const checkIsModuleConnected = useIsModuleConnectedFn();

  return (item: { requiredModule?: string }) => {
    if (item.requiredModule === undefined) {
      return true;
    }

    return checkIsModuleConnected(item.requiredModule);
  };
}
